/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Builders_Profile_EyebrowInputs */

const en_directory_builders_profile_eyebrow = /** @type {(inputs: Directory_Builders_Profile_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder profile preview`)
};

const zh_directory_builders_profile_eyebrow = /** @type {(inputs: Directory_Builders_Profile_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创作者资料预览`)
};

/**
* | output |
* | --- |
* | "Builder profile preview" |
*
* @param {Directory_Builders_Profile_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_builders_profile_eyebrow = /** @type {((inputs?: Directory_Builders_Profile_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Builders_Profile_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_builders_profile_eyebrow(inputs)
	return zh_directory_builders_profile_eyebrow(inputs)
});
export { directory_builders_profile_eyebrow as "directory.builders.profile_eyebrow" }